export default "__VITE_ASSET__293ee1a3__"